/*------------------------------------------------
// File Name:PDM_BodyCheck_PaiBanTiem.js
// File Description:PDM_BodyCheck_PaiBanTiem store方法
// Author:zxl
// Create Time:2023/05/11 18:29:22
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_PaiBanTimeList,
    GetPDM_BodyCheck_PaiBanTimeListByPage,
    GetPDM_BodyCheck_PaiBanTimeEntity,
    CreatePDM_BodyCheck_PaiBanTimeEntity,
    UpdatePDM_BodyCheck_PaiBanTimeEntity,
    DeletePDM_BodyCheck_PaiBanTimeEntity,
} from '@/api/pdm/bodycheckPaibantime'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckPaibantiem = {
    namespaced: true,
    state: {
        PdmBodycheckPaibantiemList: [],
        PdmBodycheckPaibantiemListLoading: false,
        PdmBodycheckPaibantiemEntity: null,
        PdmBodycheckPaibantiemShowDlg: false,
        ShangWuTimeList:[],
        XiaWuTimeList:[],
        PaiBanTimeShangWuList:[],
        PaiBanTimeXiagWuList:[],
        PaibantiemShowDlg:false,
    },
    mutations: {
        setPaiBanTimeShangWuList(state, dataList) {
            state.PaiBanTimeShangWuList = dataList
        },
        setPaiBanTimeXiagWuList(state, dataList) {
            state.PaiBanTimeXiagWuList = dataList
        },
        setShangWuTimeList(state, dataList) {
            state.ShangWuTimeList = dataList
        },
        setXiaWuTimeList(state, dataList) {
            state.XiaWuTimeList = dataList
        },
        setPdmBodycheckPaibantiemList(state, dataList) {
            state.PdmBodycheckPaibantiemList = [...dataList]
        },
        setPdmBodycheckPaibantiemListLoading(state, visible) {
            state.PdmBodycheckPaibantiemListLoading = visible
        },
        setPdmBodycheckPaibantiemShowDlg(state, visible) {
            state.PdmBodycheckPaibantiemShowDlg = visible
        },
        setPaibantiemShowDlg(state, visible) {
            state.PaibantiemShowDlg = visible
        },
        setPdmBodycheckPaibantiemEntity(state, entity) {
            state.PdmBodycheckPaibantiemEntity = entity
        },
    },
    actions: {
        //创建体检预约排班表-时间对象
        actCreatePdmBodycheckPaibantiem({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_PaiBanTimeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibantiemEntity', res.Data)
                        //commit('setPdmBodycheckPaibantiemShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载体检预约排班表-时间对象
        actGetPdmBodycheckPaibantiemEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckPaibantiemListLoading', true)
                GetPDM_BodyCheck_PaiBanTimeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibantiemEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckPaibantiemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载体检预约排班表-时间列表
        actGetPdmBodycheckPaibantiemList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckPaibantiemListLoading', true)
                GetPDM_BodyCheck_PaiBanTimeList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibantiemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckPaibantiemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载体检预约排班表-时间列表
        actGetPdmBodycheckPaibantiemListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckPaibantiemListLoading', true)
                GetPDM_BodyCheck_PaiBanTimeListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibantiemList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckPaibantiemListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存体检预约排班表-时间信息
        actUpdatePdmBodycheckPaibantiem({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_PaiBanTimeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckPaibantiemShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_PaiBanTiem
        actEditPdmBodycheckPaibantiemData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckPaibantiemID : entity.PdmBodycheckPaibantiemID
                }
                GetPDM_BodyCheck_PaiBanTimeEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckPaibantiemEntity', res.Data)
                        commit('setPdmBodycheckPaibantiemShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_PaiBanTiem ,传对象过来
        actEditPdmBodycheckPaibantiem({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckPaibantiemEntity', entity)
                commit('setPdmBodycheckPaibantiemShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_PaiBanTiem
        actDeletePdmBodycheckPaibantiem({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前体检预约排班表-时间？").onOk(() => {
                    DeletePDM_BodyCheck_PaiBanTimeEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckPaibantiemShowDlg', false)
                           
                            msg.success("删除体检预约排班表-时间成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除体检预约排班表-时间失败，原因:" + res.Message)
                            //msg.success("删除体检预约排班表-时间失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


